const type = 'CLOSE_LIMIT_PROPOSAL';

const closeLimitProposal = () => ({
  type,
});

export { type };
export default closeLimitProposal;
